<template>
  <div class="hello">
      <table class="tb">
        <tbody>
          <tr>
            <td width="100px">
              Target URL:
            </td>
            <td>
              <input type="text" v-model="url" style="width: 100%"/><br>
            </td>
          </tr>
          <tr>
            <td>
              Bearer Token:
            </td>
            <td>
              <textarea v-model="token" placeholder="Please input token..."  rows="10" style="width: 100%"></textarea>
            </td>
          </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="2" style="text-align: center;">
            <button @click="loginTG">Trigger</button>
          </td>
        </tr>
        </tfoot>
      </table>
  </div>
</template>

<script>
export default {
  name: 'TgLogin',
  props: {
    msg: String
  },
  data () {
    return {
      walletAddress: null,
      url: 'https://dev-wxc.openhub.network/api/vibe/sessions',
      token: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJkMmYyM2IxZGMzMWM0MTQ5OGQwYzgyYWNjYTVmODY5MCIsIndhbGxldCI6IjB4YTVjMGMyMmE2ZmQ2ZjdhZjRlY2I5NTdhNTdmNGIxMjU2MTIwMWFjYyIsImlhdCI6MTc4NjUyNzk0NSwiZXhwIjoxNzg5MTE5OTQ1fQ.QSiQkSxM4AzYBQZuB5vXRAFuAh_fJ92qAB_5R2uOUFM',
    }
  },
  methods:{
    init(){
      console.log("init...")
/*      window.addEventListener('message', (event) => {
        console.log('TG message:', event.origin, event.data)
        if (event.origin !== 'https://oauth.telegram.org') return
        const tgUser = event.data
        console.log('tgUser:', tgUser)
      })*/
    },
    async loginTG() {
/*      const botId = '8736592851' // 注意是 bot_id，不是 bot username
      const origin = window.location.origin
      const url =
          `https://oauth.telegram.org/auth` +
          `?bot_id=${botId}` +
          `&origin=${encodeURIComponent(origin)}` +
          `&request_access=write`
      console.log(url)
      window.open(url, 'telegram_login', 'width=550,height=470')*/
      console.log('url',this.url)
      console.log('token',this.token)
      //将用户信息给到后台验证
      const resp = await fetch(this.url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token
        },
      })
      const data = await resp.json()
      console.log("result",data)
    }
  },

  mounted() {
    //this.init()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn{
  margin-top: 10px;
}
.card{
  margin: 10px 20px 10px 20px;
  text-align: left;
}

/* 推荐：用 CSS 控制样式，保持结构与样式分离 */
table {
  width: 100%;
  border-collapse: collapse;  /* 合并边框，替代 cellspacing */
  font-family: Arial, sans-serif;
}

th, td {
  border: 1px solid #999;    /* 边框，替代 border 属性 */
  padding: 8px 12px;         /* 内边距，替代 cellpadding */
  text-align: left;
}
th {
  background-color: #f2f2f2;
  font-weight: bold;
}
tfoot {
  background-color: #fafafa;
  font-style: italic;
}
</style>
